import { firmasNormalize } from '../Objetos/FirmasModel';
import { certificacionesNormalize } from '../Objetos/CertificacionesModel';
import { instructorNormalize } from '../Objetos/InstructorModel';
import { leccionEstudianteNormalize } from '../Objetos/LeccionEstudianteModel';
import { catEstadosNormalize } from '../Objetos/CatEstadosModel';
import { estudianteNormalize } from '../Objetos/EstudianteModel';
import { estudiantesCursoNormalize } from '../Objetos/EstudiantesCursoModel';
import { cursosNormalize } from '../Objetos/CursosModel';
import { catNivelNormalize } from '../Objetos/CatNivelModel';
import { examenesIntentosNormalize } from '../Objetos/ExamenesIntentosModel';
import { examenesRespuestasNormalize } from '../Objetos/ExamenesRespuestasModel';
import { respuestaExamenTextoLibreNormalize } from '../Objetos/RespuestaExamenTextoLibreModel';
import { respuestaExamenVerdaderoFalsoNormalize } from '../Objetos/RespuestaExamenVerdaderoFalsoModel';
import { respuestaExamenOpcionMultipleDetNormalize } from '../Objetos/RespuestaExamenOpcionMultipleDetModel';
import { examenNormalize } from '../Objetos/ExamenModel';
import { examenPreguntasNormalize } from '../Objetos/ExamenPreguntasModel';
import { examenPreguntaTextoLibreNormalize } from '../Objetos/ExamenPreguntaTextoLibreModel';
import { examenPreguntaOpcionMultipleNormalize } from '../Objetos/ExamenPreguntaOpcionMultipleModel';
import { examenPreguntaOpcionMultipleOpcionesNormalize } from '../Objetos/ExamenPreguntaOpcionMultipleOpcionesModel';
import { examenPreguntaVerdaderoFalsoNormalize } from '../Objetos/ExamenPreguntaVerdaderoFalsoModel';
import { cuestionarioNormalize } from '../Objetos/CuestionarioModel';
import { cuestionariosPreguntasNormalize } from '../Objetos/CuestionariosPreguntasModel';
import { cuestionarioRespuestaTextoLibreNormalize } from '../Objetos/CuestionarioRespuestaTextoLibreModel';
import { cuestionarioRespuestaOpcionMultipleNormalize } from '../Objetos/CuestionarioRespuestaOpcionMultipleModel';
import { cuestionarioRespuestaOpcionMultipleOpcionesNormalize } from '../Objetos/CuestionarioRespuestaOpcionMultipleOpcionesModel';
import { cuestionarioRespuestaVerdaderoFalsoNormalize } from '../Objetos/CuestionarioRespuestaVerdaderoFalsoModel';
import { cuestionariosIntentosNormalize } from '../Objetos/CuestionariosIntentosModel';
import { cuestionariosRespuestasNormalize } from '../Objetos/CuestionariosRespuestasModel';
import { propiedadesContenidoNormalize } from '../Objetos/PropiedadesContenidoModel';
import { catPropiedadesNormalize } from '../Objetos/CatPropiedadesModel';
import { contenidoTipoNormalize } from '../Objetos/ContenidoTipoModel';
import { leccionesContenidoNormalize } from '../Objetos/LeccionesContenidoModel';
import { leccionesNormalize } from '../Objetos/LeccionesModel';
import { moduloNormalize } from '../Objetos/ModuloModel';
import { moduloContenidoNormalize } from '../Objetos/ModuloContenidoModel';
import { cursoOpinionNormalize } from '../Objetos/CursoOpinionModel';
import { cursoRatingNormalize } from '../Objetos/CursoRatingModel';
import { estudianteCertificacionesNormalize } from '../Objetos/EstudianteCertificacionesModel';
import { estudiantesPremiosNormalize } from '../Objetos/EstudiantesPremiosModel';
import { catPremiosNormalize } from '../Objetos/CatPremiosModel';
import { catTipoPreguntaNormalize } from '../Objetos/CatTipoPregunta';
import { cursoActualizarMonedasNormalize } from '../Objetos/CursoActualizarMonedasModel';
import { empleadosNormalize } from '../Objetos/Foraneos/EmpleadosModel';
import { personasNormalize } from '../Objetos/Foraneos/PersonasModel';
import { observacionCursoNormalize } from '../Objetos/ObservacionCursoModel';
import { configuracionNormalize } from '../../General/Objetos/ConfiguracionesModel';
import { carreraNormalize } from '../Objetos/CarreraModel';
import { semestreNormalize } from '../Objetos/SemestreModel';
import { semestreCursoNormalize } from '../Objetos/SemestreCursoModel';
import { carreraEstudianteNormalize } from '../Objetos/CarreraEstudianteModel';
import { asignacionMasivaUnidadOrganizacionalNormalize } from '../Objetos/AsignacionMasivaUnidadOrganizacionalModel';
import { asignacionMasivaEmpresaNormalize } from '../Objetos/AsignacionMasivaEmpresaModel';
import { asignacionMasivaAreaNegocioNormalize } from '../Objetos/AsignacionMasivaAreaNegocioModel';
import { asignacionMasivaPuestoNormalize } from '../Objetos/AsignacionMasivaPuestoModel';

import { correoPlantillaNormalize } from '../Objetos/CorreoPlantillaModel';
import { peticionFechaExtendidaNormalize } from '../Objetos/PeticionFechaExtendidaModel';

export const Models = {
    correoPlantilla: correoPlantillaNormalize,
    firmas: (x) => firmasNormalize(x),
    certificaciones: (x) => certificacionesNormalize(x),
    instructor: (x) => instructorNormalize(x),
    leccionEstudiante: (x) => leccionEstudianteNormalize(x),
    estados: (x) => catEstadosNormalize(x),               // Cat_Estados
    estudiante: (x) => estudianteNormalize(x),
    estudiantesCurso: (x) => estudiantesCursoNormalize(x),
    cursos: (x) => cursosNormalize(x),
    niveles: (x) => catNivelNormalize(x),                 // Cat_Nivel
    tipoHabilidad: (x) => ({                              // Cat_TipoHabilidad
        idTipoHabilidad: x.idTipoHabilidad ?? x.IdTipoHabilidad,
        nombre: x.nombre ?? x.Nombre,
        descripcion: x.descripcion ?? x.Descripcion,
        activo: x.activo ?? x.Activo ?? true,
    }),
    examenesIntentos: (x) => examenesIntentosNormalize(x),
    examenesRespuestas: (x) => examenesRespuestasNormalize(x),
    respuestaExamenTextoLibre: (x) => respuestaExamenTextoLibreNormalize(x),
    respuestaExamenVerdaderoFalso: (x) => respuestaExamenVerdaderoFalsoNormalize(x),
    respuestaExamenOpcionMultipleDet: (x) => respuestaExamenOpcionMultipleDetNormalize(x),
    examen: (x) => examenNormalize(x),
    examenPreguntas: (x) => examenPreguntasNormalize(x),
    examenPreguntaTextoLibre: (x) => examenPreguntaTextoLibreNormalize(x),
    examenPreguntaOpcionMultiple: (x) => examenPreguntaOpcionMultipleNormalize(x),
    examenPreguntaOpcionMultipleOpcion: (x) => examenPreguntaOpcionMultipleOpcionesNormalize(x),
    examenPreguntaVerdaderoFalso: (x) => examenPreguntaVerdaderoFalsoNormalize(x),
    cuestionario: (x) => cuestionarioNormalize(x),
    cuestionariosPreguntas: (x) => cuestionariosPreguntasNormalize(x),
    cuestionarioRespuestaTextoLibre: (x) => cuestionarioRespuestaTextoLibreNormalize(x),
    cuestionarioRespuestaOpcionMultiple: (x) => cuestionarioRespuestaOpcionMultipleNormalize(x),
    cuestionarioRespuestaOpcionMultipleOpcion: (x) => cuestionarioRespuestaOpcionMultipleOpcionesNormalize(x),
    cuestionarioRespuestaVerdaderoFalso: (x) => cuestionarioRespuestaVerdaderoFalsoNormalize(x),
    cuestionariosIntentos: (x) => cuestionariosIntentosNormalize(x),
    cuestionariosRespuestas: (x) => cuestionariosRespuestasNormalize(x),
    propiedadesContenido: (x) => propiedadesContenidoNormalize(x),
    propiedades: (x) => catPropiedadesNormalize(x),           // Cat_Propiedades
    contenidoTipo: (x) => contenidoTipoNormalize(x),
    leccionesContenido: (x) => leccionesContenidoNormalize(x),
    lecciones: (x) => leccionesNormalize(x),
    modulo: (x) => moduloNormalize(x),
    moduloContenido: (x) => moduloContenidoNormalize(x),
    cursoOpinion: (x) => cursoOpinionNormalize(x),
    cursoCalificacion: (x) => cursoRatingNormalize(x),              // CursoRating
    cursoActualizarMonedas: (x) => cursoActualizarMonedasNormalize(x),
    estudianteCertificaciones: (x) => estudianteCertificacionesNormalize(x),
    estudiantesPremios: (x) => estudiantesPremiosNormalize(x),
    premios: (x) => catPremiosNormalize(x),                  // Cat_Premios
    tipoPregunta: (x) => catTipoPreguntaNormalize(x),

    // General (modelos foráneos copiados a Lms)
    empleado: (x) => empleadosNormalize(x),
    personas: (x) => personasNormalize(x),
    observacionCurso: (x) => observacionCursoNormalize(x),
    configuracion: (x) => configuracionNormalize(x),
    carrera: (x) => carreraNormalize(x),
    semestre: (x) => semestreNormalize(x),
    semestreCurso: (x) => semestreCursoNormalize(x),
    carreraEstudiante: (x) => carreraEstudianteNormalize(x),
    asignacionMasivaUnidadOrganizacional: (x) => asignacionMasivaUnidadOrganizacionalNormalize(x),
    asignacionMasivaEmpresa: (x) => asignacionMasivaEmpresaNormalize(x),
    asignacionMasivaAreaNegocio: (x) => asignacionMasivaAreaNegocioNormalize(x),
    asignacionMasivaPuesto: (x) => asignacionMasivaPuestoNormalize(x),
}